import React, { useContext, useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation, useRoutes } from "react-router-dom";
import {
  Ic_close,
  Ic_exit,
  Ic_menu,
  mainLogo,
} from "../../helpers/ImagesCache";
import { faMedal } from "@fortawesome/free-solid-svg-icons/faMedal";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { GlobalContext, TranslationContext } from "../../helpers/Context";
import { Tooltip } from "react-tooltip";
import useTranslation from "../../hooks/useTranslation";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import DialogClearData from "../DialogClearData/DialogClearData";
import { quickClearAndReload } from "../../utils/clearAppData";
import { APP_VERSION } from "../../config/appVersion";
const Hamburger = () => {
  const globalCtx = useContext(GlobalContext);
  const translateContext = useContext(TranslationContext);
  const T = useTranslation();
  const location = useLocation();
  const { hash, pathname, search } = location;
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const [showClearDataDialog, setShowClearDataDialog] = useState(false);
  const [isClearing, setIsClearing] = useState(false);

  const handlerOpenMenu = () => {
    setIsOpenMenu(!isOpenMenu);
  };

  const handleTranslate = (to) => {
    return to;
  };

  const handleClearData = () => {
    setShowClearDataDialog(true);
  };

  const handleConfirmClearData = () => {
    setIsClearing(true);
    
    // Close the menu to avoid UI conflicts
    setIsOpenMenu(false);
    
    // Use the quick clear function that reloads immediately
    quickClearAndReload();
  };

  const handleCloseClearDataDialog = () => {
    if (!isClearing) {
      setShowClearDataDialog(false);
    }
  };
  const LateralMenu = () => {
    const MenuItem = ({
      title,
      icon,
      iconImage,
      to,
      between,
      direction,
      className,
      onClick,
    }) => {
      return (
        <>
          {!onClick && (
            <Link
              to={to}
              className={
                className +
                `w-full p-[16px] flex gap-8 hover:bg-[#EAF7F5] ${
                  pathname == to ? "bg-[#EAF7F5]" : "bg-[#fff]"
                }`
              }
              style={{
                justifyContent: between ? "between" : "flex-start",
                alignItems: "center",
                flexDirection: direction ? direction : "row",
              }}
            >
              <span className="font-[600] w-11/12 text-left text-base">
                {T(title)}
              </span>
              <span className="w-1/12">
                {icon && <FontAwesomeIcon icon={icon} />}
              </span>
            </Link>
          )}
          {onClick && (
            <button
              onClick={onClick}
              className={
                className +
                `  w-full  p-[16px] flex gap-8 hover:bg-[#EAF7F5] ${
                  pathname == to ? "bg-[#EAF7F5]" : "bg-[#fff]"
                }`
              }
              style={{
                justifyContent: between ? "between" : "flex-start",
                alignItems: "center",
                flexDirection: direction ? direction : "row-reverse",
              }}
            >
              {iconImage && <img className="h-6 w-6" src={iconImage} alt="" />}
              <span className="font-[600] w-11/12 text-left text-base pl-2">
                {T(title)}
              </span>
              {!iconImage && (
                <span className="w-1/12">
                  {icon && <FontAwesomeIcon icon={icon} />}
                </span>
              )}
            </button>
          )}
        </>
      );
    };

    const MenuItemComp = ({
      iconImage,
      title,
      icon,
      to,
      between,
      direction,
      className,
      Comp,
    }) => {
      const redirect = handleTranslate(to);
      return (
        <>
          {
            <div
              className={
                className +
                ` w-full  p-[16px] flex hover:bg-[#EAF7F5] ${
                  pathname == to ? "bg-[#EAF7F5]" : "bg-[#fff]"
                }`
              }
              style={{
                justifyContent: between ? "between" : "flex-start",
                alignItems: "center",
                flexDirection: direction ? direction : "row-reverse",
              }}
            >
              <div className="flex justify-between font-[500] w-full text-left text-base">
                <span>{T(title)}</span>
                <Comp />
              </div>
              {icon && (
                <Link to={redirect} className="w-1/12">
                  <FontAwesomeIcon icon={icon} />
                </Link>
              )}
              {iconImage && (
                <Link to={redirect} className="w-1/12">
                  <img className="h-6 w-6" src={iconImage} alt="" />
                </Link>
              )}
            </div>
          }
        </>
      );
    };

    return (
      <>
        <div
          className="fixed flex left-0 top-0 bg-[#0005] w-full h-[100dvh] "
          style={{ zIndex: 10001 }}
        >
          <div className="w-[80%] h-[100dvh] flex flex-col items-end justify-between bg-white ">
            <div className="flex justify-between w-full h-16 items-center mt-2 border-b-[1px] pb-2 pr-2">
              <img
                src={mainLogo}
                alt={"LOGO"}
                className="w-[50%] h-[60%] ml-3 object-contain"
              />
              <img
                onClick={handlerOpenMenu}
                className="h-6 w-6 cursor-pointer"
                src={Ic_close}
              />
            </div>
            <div className=" w-full h-full font-[900] z-1">
              <MenuItem
                title={"Nivel de simulación"}
                className="home-tooltip border-b-[1px]"
                to={"/"}
              />
              <hr className="mx-[16px]" />
              <MenuItem
                title={"Informes"}
                className="informes-tooltip  border-b-[1px]"
                to={"/reports"}
              />
              <hr className="mx-[16px]" />
              <MenuItemComp
                title={T("Idioma")}
                className="language-tooltip"
                to={"/language"}
                Comp={() => <LanguageSelector />}
                between={true}
              />
              <hr className="mx-[16px]" />
              <MenuItem
                title={"Acerca de"}
                className="about-tooltip  border-b-[1px]"
                to={"/about"}
              />
              <hr className="mx-[16px]" />
              <MenuItem
                title={"help_title"}
                className="help-tooltip  border-b-[1px]"
                to={"/help"}
              />
              <hr className="mx-[16px]" />
              <MenuItem
                title={"privacy_policy_title"}
                className="privacy-policy-tooltip  border-b-[1px]"
                to={"/privacy-policy"}
              />
              <hr className="mx-[16px]" />
              <MenuItem
                title={"feedback_title"}
                className="feedback-tooltip  border-b-[1px]"
                to={"/feedback"}
              />
              <hr className="mx-[16px]" />
            </div>
            <div className="border-t w-full flex flex-col">
              <hr />
              
              {/* Botón discreto para borrar datos - solo para QA */}
              <div className="px-4 py-2">
                <button
                  onClick={handleClearData}
                  className="clear-data-tooltip text-xs text-gray-400 hover:text-gray-600 transition-colors duration-200 opacity-50 hover:opacity-75"
                  style={{ fontSize: '10px' }}
                >
                  🗑️ Dev: Clear Data
                </button>
              </div>
              
              {/* Versión de la aplicación */}
              <div className="px-4 py-1">
                <div className="text-xs text-gray-400 opacity-50" style={{ fontSize: '10px' }}>
                  📱 v{APP_VERSION}
                </div>
              </div>
          
              <div className="text-red-500 text-lg">
            
                <Tooltip anchorSelect=".language-tooltip" place="bottom">
                  {T("Cambiar idioma")}
                </Tooltip>
                <Tooltip anchorSelect=".informes-tooltip" place="bottom">
                  Ver informes
                </Tooltip>
                <Tooltip anchorSelect=".basic-tooltip" place="bottom">
                  Simulacion Soporte Vital Basico + DEA
                </Tooltip>
                <Tooltip anchorSelect=".advanced-tooltip" place="bottom">
                  Simulacion Soporte Vital Avanzado
                </Tooltip>
                <Tooltip anchorSelect=".ovace-tooltip" place="bottom">
                  Simulacion OVACE
                </Tooltip>
                <Tooltip anchorSelect=".privacity-tooltip" place="bottom">
                  Ver politicas de privacidad
                </Tooltip>
                <Tooltip anchorSelect=".about-tooltip" place="bottom">
                  Acerca de los creadores, version...
                </Tooltip>
                <Tooltip anchorSelect=".help-tooltip" place="bottom">
                  Glosario de términos y guía de botones
                </Tooltip>
                <Tooltip anchorSelect=".privacy-policy-tooltip" place="bottom">
                  Información sobre el tratamiento de datos personales
                </Tooltip>
                <Tooltip anchorSelect=".feedback-tooltip" place="bottom">
                  Cuéntanos tu opinión sobre la aplicación
                </Tooltip>
                <Tooltip anchorSelect=".clear-data-tooltip" place="top">
                  Solo para QA: Borra localStorage, cache y reinicia la app
                </Tooltip>
              </div>
            </div>
          </div>
          <div
            className="bg-[#0001]"
            style={{ width: "calc(100vw - 200px)" }}
            onClick={handlerOpenMenu}
          ></div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="min-w-[40px] relative" style={{ zIndex: 10001 }}>
        {!isOpenMenu && (
          <img
            onClick={handlerOpenMenu}
            className="h-[40px] w-[40px] cursor-pointer"
            src={Ic_menu}
            alt="Menu"
          />
        )}
        {isOpenMenu && <LateralMenu />}
      </div>
      <DialogClearData
        visible={showClearDataDialog}
        onClose={handleCloseClearDataDialog}
        onConfirm={handleConfirmClearData}
        isClearing={isClearing}
      />
    </>
  );
};
export default Hamburger;
